import AdminGpusTable from "../../components/admin/gpus/table";

export default function AdminGpusPage() {
  return <AdminGpusTable />;
}
